// extracted by mini-css-extract-plugin
module.exports = {"labelContainer":"Webcam_labelContainer__HrSYB","webcams":"Webcam_webcams__1r1un"};